// extracted by mini-css-extract-plugin
export default {"ques":"FAQ_ques__6Qu9U","title":"FAQ_title__lBD+A","FAQ":"FAQ_FAQ__thgnn","icon":"FAQ_icon__fMGRL","ans":"FAQ_ans__bvbkL","show":"FAQ_show__vMy4A"};